module.exports = __webpack_public_path__ + "static/media/cunningham-contracts-group.d6eee990.png";